export const fonts = {
  inter: "'Inter', sans-serif",
  archivo: "'Archivo', sans-serif",
  archivoBlack: "'Archivo Black', sans-serif",
};
